/**
 * Finds the rendered sections of a slot on a page the site rendered (a
 * preview frame). Live pages add no wrapper per section: each top-level
 * section's root is a direct child of the slot's div (data-gx-slot). A section
 * that renders nothing or several roots breaks that; then the slot is skipped
 * (null) rather than marking the wrong section.
 */
/** A CSS selector for a slot's div. */
export const slotSelector = (slotId: string): string => {
  const escaped = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(slotId) : slotId.replace(/["\\]/g, '\\$&');
  return `[data-gx-slot="${escaped}"]`;
};

export const sectionElements = (doc: Document, slotId: string, sectionCount: number): Element[] | null => {
  const slot = doc.querySelector(slotSelector(slotId));
  if (!slot) return null;
  const children = Array.from(slot.children);
  return children.length === sectionCount ? children : null;
};
